module.exports = __webpack_public_path__ + "static/media/sem_imagem.0eb72eca.svg";